import { InstagramImg } from "app/constants";

const GithubIcon = () => {
  return <img width="24" height="24" src={InstagramImg} alt="Coingecko-icon" />;
};

export default GithubIcon;
